document.addEventListener('variant:change', function(event) {
    const variant = event.detail.variant;
    
    if (!variant) return;
    const outOfStockForm = document.getElementById('out-of-stock-form');
    if (!outOfStockForm) return;

    const variantInput = outOfStockForm.querySelector('input[name="variant_id"]');
    const sizeInput = outOfStockForm.querySelector('input[name="size"]');
    const colorInput = outOfStockForm.querySelector('input[name="color"]');

    // Guard against missing inputs
    if (!variantInput || !sizeInput || !colorInput) return;

    variantInput.value = variant.id;
    colorInput.value = variant.option1;
    sizeInput.value = variant.option2;
    
    if (!variant.available) {
        // Show the out-of-stock form
        outOfStockForm.classList.remove('hide');
    } else {
        // Hide the out-of-stock form
        outOfStockForm.classList.add('hide');
    }
});